import { Typography } from "@vp/swan";
import React from "react";

import { useLocalization } from "../../../hooks/useLocalizations";
import { SavingsPercentageProps } from "../../../types/priceVariants/savings-percentage";

const SavingsPercentage = ({ savingsPercentage, quantity, moq, vatInc }: SavingsPercentageProps) => {
  const { t } = useLocalization();

  if ((moq && quantity === moq)) {
    return (
      <Typography as="span" fontSkin="body-small-bold" textColor="subtle">
        {t("price-platform.volume-pricing")}
      </Typography>
    );
  }

  if (moq && quantity && quantity > moq && savingsPercentage) {
    const percentage = vatInc ? savingsPercentage.taxed : savingsPercentage.untaxed;
    if (percentage <= 0) {
      return <></>;
    }
    return (
      <Typography as="span" fontSkin="body-small-bold" textColor="subtle">
        {t("price-platform.savings-with-volume-pricing", { Percentage: percentage })}
      </Typography>
    );
  }

  return <></>;
};

export { SavingsPercentage };
